var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 118,
    viewBox: "0 0 130 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76023 108.602C2.69954 108.132 2.04006 107.066 2.04713 105.906L2.20549 79.9238C2.29293 65.5771 14.8546 54.0229 30.2628 54.1168L33.9827 54.1395C44.2548 54.2021 52.5347 62.0064 52.4764 71.5709L52.2571 107.552C52.2505 108.638 51.5986 109.615 50.5804 109.994C48.885 110.624 47.1313 109.326 47.1424 107.518L47.3273 77.1681C47.3317 76.4507 46.7107 75.8654 45.9403 75.8607C45.1699 75.856 44.5418 76.4337 44.5374 77.1511L44.3395 109.624C44.3312 110.989 43.403 112.185 42.0675 112.471C37.7109 113.404 33.1695 113.884 28.5037 113.856C25.2318 113.836 22.2937 113.566 19.2843 113.067C17.8683 112.832 16.8605 111.583 16.8696 110.148L17.0593 80.2866C17.0644 79.4497 16.1235 78.7668 15.2247 78.7613C14.3259 78.7559 13.3768 79.4299 13.3717 80.2668L13.1952 108.023C13.1828 109.977 11.3342 111.399 9.47706 110.793C7.52189 110.154 5.61422 109.422 3.76023 108.602Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6258 30.1517C47.4294 40.0474 40.1924 48.6186 30.4615 49.2958C20.7306 49.9731 11.7257 42.4972 10.9221 32.6014C10.1185 22.7056 17.8204 14.1373 27.5513 13.4601C37.2822 12.7828 45.8221 20.2559 46.6258 30.1517Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6118 2C61.8504 2 59.6118 4.23857 59.6118 7V31.435C59.6118 34.1965 61.8504 36.435 64.6118 36.435H64.6199L62.2563 42.1339C62.0647 42.5959 62.5951 43.0219 63.0049 42.7351L72.0049 36.435H108.251C111.012 36.435 113.251 34.1965 113.251 31.435V7C113.251 4.23858 111.012 2 108.251 2H64.6118Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.497 25.1774C123.258 25.1774 125.497 27.416 125.497 30.1774V38.5269C125.497 40.5252 124.325 42.2498 122.63 43.0503L124.175 46.7743C124.252 46.9591 124.039 47.1295 123.875 47.0148L118.893 43.5269H98.3855C95.6241 43.5269 93.3855 41.2883 93.3855 38.5269V30.1774C93.3855 27.416 95.6241 25.1774 98.3855 25.1774H120.497Z",
    fill: "#FCE9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5794 45.1049C26.4484 45.0581 25.2156 43.2272 24.6124 41.6041C24.3536 40.9078 25.0026 40.3792 25.6843 40.6745C26.5885 41.066 27.6864 41.5228 28.4438 41.7028C29.4955 41.9526 31.0996 41.9066 32.5789 41.7599C33.5349 41.6651 34.096 42.752 33.3166 43.3137C31.9648 44.2881 30.26 45.1419 28.5794 45.1049Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 14.5C69 13.6716 69.6716 13 70.5 13H102.5C103.328 13 104 13.6716 104 14.5C104 15.3284 103.328 16 102.5 16H70.5C69.6716 16 69 15.3284 69 14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 32C120 31.4477 119.552 31 119 31H99C98.4477 31 98 31.4477 98 32C98 32.5523 98.4477 33 99 33H119C119.552 33 120 32.5523 120 32Z",
    fill: "#FFB84E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 20.5C69 19.6716 69.6716 19 70.5 19H90.5C91.3284 19 92 19.6716 92 20.5C92 21.3284 91.3284 22 90.5 22H70.5C69.6716 22 69 21.3284 69 20.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120 36C120 35.4477 119.552 35 119 35H106C105.448 35 105 35.4477 105 36C105 36.5523 105.448 37 106 37H119C119.552 37 120 36.5523 120 36Z",
    fill: "#FFB84E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_570",
    x: 0.046875,
    y: 0,
    width: 129.45,
    height: 117.857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_570",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.dba40b740dcc94bb46f4ad6afba08a76.svg";
export { ForwardRef as ReactComponent };